module.exports = __webpack_public_path__ + "assets/68aabfd2ab16da84099d3475b3b669d4.svg";